import { handleActions, combineActions } from 'redux-actions';
import { pastOrders as actions } from '../../../Actions';

const initialState: any = {
    period: '1 week',
    syncInProgress: false,
    renderModal: false,
    productReviewsEnabled: false,
    businessUnitId: '',
    invitationSettings: undefined,
    status: {},
    isFetching: false,
    pastOrders: {
        showInitial: true,
    },
    selectedShops: [],
    isFetchingPastOrdersSettings: true,
    analyze: null,
    features: [],
};

const pastOrders = handleActions<any, any>({
    [actions.fetchStatus]: (state, { payload }) => ({ ...state, ...payload }),
    [actions.receiveStatus]: (state, { payload }) => ({ ...state, ...payload }),
    [actions.setPeriod]: (state, { payload }) => ({ ...state, ...payload }),
    [combineActions(actions.fetchPastOrdersSettings, actions.receivePastOrdersSettings) as any]: (state: any, action: any): any => ({
        ...state,
        ...action.payload,
    }),
    [combineActions(actions.startSync, actions.stopSync) as any]: (state: any, action: any): any => ({
        ...state,
        ...action.payload,
    }),
    [actions.setRenderModal as any]: (state: any, action: any) => ({
        ...state,
        ...action.payload,
    }),
    [actions.setSelectedShops]: (state, { payload }) => ({ ...state, ...payload }),
    [actions.receiveAnalyze]: (state, { payload }) => ({ ...state, ...payload }),
}, initialState);

export default pastOrders;



// WEBPACK FOOTER //
// ./src/redux/reducers/PastOrders/index.ts